<script setup>
import { onMounted, ref } from 'vue';
import { Tooltip } from 'bootstrap';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  placement: {
    type: String,
    default: 'top',
  },
});

const tooltip = ref();

onMounted(() => {
  // eslint-disable-next-line no-new
  new Tooltip(tooltip.value);
});
</script>

<template>
  <button
    ref="tooltip"
    type="button"
    data-bs-toggle="tooltip"
    :title="props.title"
    :data-bs-placement="props.placement"
  >
    <slot />
  </button>
</template>

<style lang="scss">
[data-bs-toggle='tooltip'] {
  padding: 0;

  border: none;
  background: transparent;
}

@media (min-width: $screen-sm) {
  .tooltip-inner {
    font-size: 16px !important;
    width: 100%!important;
    max-width: unset!important;
  }
}
</style>
